module.exports = __webpack_public_path__ + "img/img_whenIsUseful2.baf89da9.svg";